import * as React from 'react';
import * as Glob from '../Globale';
import * as Compat from '../Compat';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';
import { Trad } from '../components/';
import { Dictionary } from '../Dati';


interface ICampoMultiSelezioneProps extends Dati.IBaseProps {
    Valori: Glob.DatiJSON | Dictionary<boolean>; //JSON
    Grafica?: string;
    BloccoAltezza?: boolean;
    Etichetta?: any;
    OnChange: (e: React.FormEvent<any> | string, valore?: any, changedFields?: Dati.Dictionary<boolean>) => any;

}

export class CampoMultiSelezione extends BasePureComponent<ICampoMultiSelezioneProps, {}> {

    private _Valori: Dati.CDictionary<boolean> = new Dati.CDictionary<boolean>();
    private _Grafica: string = "";
    private _CSSMultiInfo: string = "multiinfo";
    private _Etichetta: any = "";
    private _ChangedFields: Dati.CDictionary<boolean> = new Dati.CDictionary<boolean>();

    constructor(props: any) {
        super(props);
    }

    private Inizializza(props: ICampoMultiSelezioneProps) {
        this._Grafica = props.Grafica == undefined ? "Standard" : props.Grafica;
        this._CSSMultiInfo = props.BloccoAltezza == undefined || props.BloccoAltezza ? "multiinfoLimite" : "multiinfo";
        this._Etichetta = props.Etichetta == undefined || !props.Etichetta ? "" : props.Etichetta;
        if (typeof (props.Etichetta) == "string") {
            this._Etichetta = <label>{props.Etichetta}</label>;
        }
        this.PopolaValori(props.Valori);
    }

    private PopolaValori(valore: string | Dictionary<boolean>) {
        this._Valori = new Dati.CDictionary<boolean>();
        if (valore != undefined && valore != "" && typeof (valore) == "string") {
            this._Valori.LoadFromJSON(valore);
        } else if (valore != undefined && valore != "" && typeof (valore) != "string") {
            this._Valori.LoadFromDictionary(valore);
        } else {
            this._Valori = new Dati.CDictionary<boolean>();
        }
    }

    private UpdateChangedFields(name: string, value: boolean){
        if (this._ChangedFields.ContainsKey(name)) {
            this._ChangedFields.Remove(name);
        } else {
            this._ChangedFields.Set(name, value);
        }
    }

    protected OnAggiorna(e: React.FormEvent<any>): void {
        if ((e.currentTarget as HTMLInputElement).type == "checkbox") {
            this._Valori.Set(e.currentTarget.name, e.currentTarget.checked);
            this.UpdateChangedFields(e.currentTarget.name, e.currentTarget.checked);
        } else if ((e.currentTarget as HTMLInputElement).type == "radio") {
            var radios: NodeListOf<HTMLElement> = document.getElementsByName(e.currentTarget.name)
            for (var i = 0; i < radios.length; i++) {
                this._Valori.Set(radios[i].id, (radios[i].id == e.currentTarget.id));
                this.UpdateChangedFields(radios[i].id, (radios[i].id == e.currentTarget.id));
            }
        }

        this.props.OnChange(this.props.Name, this._Valori.GetDictionary(), this._ChangedFields.GetDictionary());
    }

    private Abilita(value: boolean): string {

        if (value) {
            return "btn btn-brand btn-sm multiselezioneBottone";
        }
        else {
            return "btn btn-secondary btn-sm multiselezioneBottone";
        }
        /*
        switch (this._Grafica) {
            case "Radio":
                if (value) {
                    return "kt-radio kt-radio--solid kt-radio--brand";
                }
                else {
                    return "kt-radio kt-radio--solid kt-radio--brand--disabled";
                }
            case "CheckBox":
            default:
                if (value) {
                    return "btn btn-brand btn-sm multiselezioneBottone";
                }
                else {
                    return "btn btn-secondary btn-sm multiselezioneBottone";
                }
        }
        */
    }

    private GraficaStandard(): any {
        let elementi: string[] = this._Valori.Keys().sort((one, two) => (Trad.Trad(one) < Trad.Trad(two) ? -1 : 1));
        let elementiHTML: any[] = [];
        let sottoElementiHTML: any[] = [];
        let macroGruppiHTML: any[] = [];
        let Primalettera: string = "";
        let ElementiSelezionati: any[] = [];

        for (var i = 0; i < elementi.length; i++) {
            if (Trad.Trad(elementi[i]).substr(0, 1) != Primalettera) {
                elementiHTML.push(<div key={"elem" + i} className="kt-list-badge__items">
                    {sottoElementiHTML}
                </div>)
                macroGruppiHTML.push(<div key={"macro" + i} className="kt-list-badge kt-list-badge--light-bg">
                    <div className="kt-list-badge__label kt--font-success">{Primalettera}</div>
                    {elementiHTML}
                </div>);
                elementiHTML = [];
                Primalettera = Trad.Trad(elementi[i]).substr(0, 1);
                sottoElementiHTML = [];
            }
            sottoElementiHTML.push(<label key={"label_" + i} className={this.Abilita(this._Valori.Item(elementi[i]))}>{Trad.Trad(elementi[i])}
                <input name={elementi[i]} id={elementi[i]} type="checkbox" checked={this._Valori.Item(elementi[i])} onChange={(e) => this.OnAggiorna(e)} hidden />
            </label>);

            if (this._Valori.Item(elementi[i]))
                ElementiSelezionati.push(<button type="button" className="btn btn-outline-brand btn-sm multiselezioneBottone" key={"btn_" + i}>{Trad.Trad(elementi[i])}</button>)
        }
        elementiHTML.push(<div key={"elem" + i} className="kt-list-badge__items">
            {sottoElementiHTML}
        </div>)
        macroGruppiHTML.push(<div key="macrofine" className="kt-list-badge kt-list-badge--light-bg">
            <div className="kt-list-badge__label kt--font-success">{Primalettera}</div>
            {elementiHTML}
        </div>);


        if (this._CSSMultiInfo != "multiinfo") {
            return <div>
                <div className={this._CSSMultiInfo}>
                    {macroGruppiHTML}
                </div>
                <div className="multiinfo">
                    <div className="kt-list-badge kt-list-badge--light-bg">
                        <div className="kt-list-badge__label kt--font-success">{Trad.Trad("Selezionati")}</div>
                        <div className="kt-list-badge__items">
                            {ElementiSelezionati}
                        </div>
                    </div>
                </div>
            </div>;
        } else {
            return <div className={this._CSSMultiInfo}>
                {macroGruppiHTML}
            </div>;
        }
    }

    private GraficaCheckBox(): any {
        let elementi: string[] = this._Valori.Keys().sort((one, two) => (Trad.Trad(one) < Trad.Trad(two) ? -1 : 1));
        let elementiHTML: any[] = [];
        let sottoElementiHTML: any[] = [];
        let macroGruppiHTML: any[] = [];
        let ElementiSelezionati: any[] = [];

        for (var i = 0; i < elementi.length; i++) {
            sottoElementiHTML.push(<label key={"label_" + i} className={this.Abilita(this._Valori.Item(elementi[i]))}>{Trad.Trad(elementi[i])}
                <input name={elementi[i]} id={elementi[i]} type="checkbox" checked={this._Valori.Item(elementi[i])} onChange={(e) => this.OnAggiorna(e)} hidden />
            </label>);

            if (this._Valori.Item(elementi[i]))
                ElementiSelezionati.push(<button type="button" className="btn btn-outline-brand btn-sm multiselezioneBottone" key={"btn_" + i}>{elementi[i]}</button>)
        }
        elementiHTML.push(<div key={"elem" + i} className="kt-list-badge__items">
            {sottoElementiHTML}
        </div>)
        macroGruppiHTML.push(<div key="macrofine" className="kt-list-badge kt-list-badge--light-bg" style={{ marginTop: this._CSSMultiInfo == "multiinfo" ? -8 : "unset" }}>
            {elementiHTML}
        </div>);


        if (this._CSSMultiInfo != "multiinfo") {
            return <div>
                <div className={this._CSSMultiInfo}>
                    {this._Etichetta}
                    {macroGruppiHTML}
                </div>
                <div className="multiinfo">
                    <div className="kt-list-badge kt-list-badge--light-bg">
                        <div className="kt-list-badge__label kt--font-success">{Trad.Trad("Selezionati")}</div>
                        <div className="kt-list-badge__items">
                            {ElementiSelezionati}
                        </div>
                    </div>
                </div>
            </div>;
        } else {
            return <div className={this._CSSMultiInfo}>
                {this._Etichetta}
                {macroGruppiHTML}
            </div>;
        }
    }

    private GraficaRadio(): any {
        let elementi: string[] = this._Valori.Keys().sort((one, two) => (Trad.Trad(one) < Trad.Trad(two) ? -1 : 1));
        let elementiHTML: any[] = [];
        for (var i = 0; i < elementi.length; i++) {
            elementiHTML.push(<div key={"elem" + i} >
                <label className={this.Abilita(this._Valori.Item(elementi[i]))}>{Trad.Trad(elementi[i])}
                    <input name={this.props.Name} id={elementi[i]} type="radio" checked={this._Valori.Item(elementi[i])} onChange={(e) => this.OnAggiorna(e)} hidden />
                </label>
            </div>)
        }

        return <div className={this._CSSMultiInfo}>
            {elementiHTML}
        </div>;
    }

    public render() {
        this.Inizializza(this.props);
        switch (this._Grafica) {
            case "CheckBox":
                return this.GraficaCheckBox();
            case "Radio":
                return this.GraficaRadio();
            case "Standard":
            default:
                return this.GraficaStandard();
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/CampoMultiSelezione.tsx